import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ConsultAvailablePTTView from "./ConsultAvailablePTTView";
import {Column} from "primereact/column";
import {numberWithComma, numberWithCommaDataTableTemplate} from "../../../../utils/formatters/Numbers";
import {DataTable} from "primereact/datatable";
import {Builder} from "../../../../utils/lists/ListProcessor";
import {ConsultAvailablePTTService} from "../../../../service/operation/availableValuesPTM/ConsultAvailablePTTService";
import {CatalogService} from "../../../../service/catalog/CatalogService";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {PTT_ROL} from "../../../../utils/constants/Constants";

export default class ConsultAvailablePTTContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);
        this.consultAvailablePTTService = new ConsultAvailablePTTService();
        this.catalogService = new CatalogService();
        this.getDataConsult = this.getDataConsult.bind(this);
        this.getInstitutions = this.getInstitutions.bind(this);

        this.state = {
            dataConsultAvailable: {},
            institutionObj: {},
            isLoading: false,
            expanded: false,
            totalSum: 0,
            institutionList: this.getInstitutions(),
        };
        this.totalSum = 0;

        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.searchInstitution = this.searchInstitution.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false
            });
        }
    }

    /**
     * Función que consulta al back para obtener la información de la pantalla
     * Disponible detalle que se muestra en una tabla.
     * @param emisoraStr Argumento que indica lo que se va a buscar.
     *                  Si viene vacío, se trae toda la información
     * @returns {Promise<void>} Lista que se mostrará en la tabla.
     */
    getDataConsult(idInstitution) {
        this.loading(true);
        return this.consultAvailablePTTService.getDetailEmailAvailablePTM(idInstitution)
            .then(resp => {
                let totalSum = this.calculateTotalSum(resp.payload, 'cantidadCorreo');
                let builder = new Builder();
                builder.groupList(resp.payload, 'emision');
                this.setState({
                    dataConsultAvailable: builder.mapObjects,
                    expanded: false,
                    expandedRows: [],
                    totalSum: totalSum,
                });
                this.loading(false);
            });
    }

    calculateTotalSum(data, field) {
        let sum = 0;
        data.forEach(item => {
            sum = sum + item[field];
        });
        return sum;
    }

    getInstitutions() {
        this.catalogService.getCatalogInstitutionByRol(PTT_ROL)
            .then(resp => {
                this.setState({
                    institutionList: resp,
                });
            });
    }

    /**
     * Función que se manda a la vista para que se ejecute cuando se da clic en el
     * botón de buscar, ya que busca el texto que se encuentra en la sección
     * de filtros.
     */
    searchInstitution() {
        this.loading();
        if (!this.state.institutionObj.idInstitucion) {
            this.growl.show({
                severity: 'error', summary: 'Atención.',
                detail: 'Seleccione una institución prestataria'
            });
        } else {
            this.getDataConsult(this.state.institutionObj.idInstitucion);
        }
    }

    /**
     * Función que maneja el cambio de texto en el campo de texto de los filtros
     * Coloca el valor en una variable del estado.
     * @param event Contiene el valor y el objeto modificado.
     */
    onChangeFilter(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    /**
     * Función que limpia el valor que se encuentra en la caja de texto de los filtros.
     */
    clearFilters() {
        this.setState({institutionObj: {}})
    }

    /**
     * Función que maneja qué fila fue seleccionada para expandirla
     * y mostrar la lista que contiene.
     * @param event Evento que trae la información de la opción expandida.
     */
    handleToggle = (event) => {
        this.setState({
            expandedRows: event.data,
        })
    };

    /**
     * Función que realiza un template de las listas que se contienen en las emisoras
     * Realiza una tabla donde las muestra.
     * @param data Información de la lista contenida en cada renglón principal.
     * @returns {*} Template para cada una de las cuentas
     */
    rowExpansionTemplate(data) {
        const itemsInstitution = data.items;
        let sum = this.calculateTotalSum(data.items, 'cantidadCorreo');
        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="" colSpan={5}/>
                    <Column footer={numberWithComma(sum, 'right')}/>
                </Row>
            </ColumnGroup>;

        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    footerColumnGroup={footerColumnGroup}
                    value={itemsInstitution}
                    selectionMode="single"
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="nomCorto" header="InstitucionPTM" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="cantidad" header="Cantidad Cargada" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="cantidadDisponible" header="Cantidad Disponible" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="precio24Hrs" header="Precio" style={{textAlign: 'right'}}
                            body={this.formatNumberTemplate} sortable={true}/>
                    <Column field="importeDisponible" header="Importe Disponible" style={{textAlign: 'right'}}
                            body={this.formatNumberTemplate} sortable={true}/>
                    <Column field="cantidadCorreo" header="Cantidad Correo" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                </DataTable>
            </div>
        );
    }

    formatNumberTemplate(rowData, column) {
        let nDecimals = column['field'] === "precio24Hrs" ? 6 : 2;
        return numberWithComma(rowData[column['field']], "right",
            false, nDecimals, true);
    }

    /**
     * Función que se encarga de contraer y expandir los grupos de
     * emisoras en el dataTable
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.dataConsultAvailable,
                expanded: true,
            });
        }
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let footerColumnGroup = this.state.totalSum === 0 ? "" :
            <ColumnGroup>
                <Row>
                    <Column footer={numberWithComma(this.state.totalSum, "right")} colSpan={2}/>
                </Row>
            </ColumnGroup>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataConsultAvailable, institutionObj, isLoading, expandedRows,
            institutionList
        } = this.state;

        return <ConsultAvailablePTTView dataConsultAvailable={dataConsultAvailable}
                                        isLoading={isLoading}
                                        institutionObj={institutionObj}
                                        messagesGrowl={messagesGrowl}
                                        expandedRows={expandedRows}
                                        footerColumnGroup={footerColumnGroup}
                                        institutionList={institutionList}
                                        rowExpansionTemplate={this.rowExpansionTemplate}
                                        expandReduceAll={this.expandReduceAll}
                                        handleToggle={this.handleToggle}
                                        onChangeFilter={this.onChangeFilter}
                                        clearFilters={this.clearFilters}
                                        searchInstitution={this.searchInstitution}
        />
    }
};